import { makeStyles } from "@material-ui/core/styles";
import React from "react";

import leftQouteImg from "assets/images/quote_left.png";
import rightQuoteImg from "assets/images/quote_right.png";
import {Container, Grid, Typography, useTheme} from "@material-ui/core";
import img from "../../assets/images/testimony_img_1.png";



export default function QuoteContainer(props) {
  const theme = useTheme();
  const { text, note = "", name } = props
  return (
      <Container
          maxWidth="md"
          style={{
            textAlign: "center",
            color: theme.palette.secondary.main,
            padding: 20,
          }}
      >
        <Grid container>
          <Grid
              item
              xs={2}
              container
              direction="row"
              justify="center"
              alignItems="center"
          >
            <Grid item>
              <img src={leftQouteImg} alt="left Qoute Img" width="50%" />
            </Grid>
          </Grid>
          <Grid
              item
              xs={8}
              container
              direction="column"
              justify="space-between"
              alignItems="center"
          >
            {typeof props.text === "string" &&
            <Grid item>
              <Typography variant="body1">
                <i>{props.text}</i>
              </Typography>
            </Grid>}

            {typeof props.text === "object" && props.text.map((item, index) => {
              return   <Grid item>
                <Typography variant="body1" style={{textAlign: "left", marginBottom: 5}}>
                  <i>{item}</i>
                </Typography>
              </Grid>
            })}
            {note === "" ? (
                <Grid item>
                  <Typography variant="subtitle1">{props.note}</Typography>
                </Grid>
            ) : (
                null
            )}
            <Grid item>
              <Typography variant="subtitle2"><strong>{props.name}</strong></Typography>
            </Grid>
          </Grid>
          <Grid
              item
              xs={2}
              container
              direction="row"
              justify="center"
              alignItems="center"
          >
            <Grid item>
              <img src={rightQuoteImg} alt="right Quote Img" width="50%" />
            </Grid>
          </Grid>
        </Grid>
      </Container>
  );
}